import { render, staticRenderFns } from "./PersoInfo.vue?vue&type=template&id=24ff9865&scoped=true"
import script from "./PersoInfo.js?vue&type=script&lang=js&external"
export * from "./PersoInfo.js?vue&type=script&lang=js&external"
import style0 from "./PersoInfo.scss?vue&type=style&index=0&id=24ff9865&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff9865",
  null
  
)

export default component.exports